import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthHttpIntercepter implements HttpInterceptor {
  constructor() { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.startsWith('https://us-street.api.smartystreets.com/')) {

      request = request.clone({
        setHeaders: {
          // Authorization: `Bearer ${this.auth.getToken()}`,
          'Api-Key': environment.authentication.apiKey,
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache'
        }
      });
    };
    return next.handle(request);
  }
}





// WEBPACK FOOTER //
// ./src/app/core/handlers/AuthHttpIntercepter.ts